/* eslint-disable @typescript-eslint/no-explicit-any */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Date custom scalar type */
  Date: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
};

export type Address = {
  __typename?: 'Address';
  accessDetails?: Maybe<Scalars['String']['output']>;
  city: City;
  country: Country;
  id: Scalars['Int']['output'];
  locationType: LocationType;
  state: State;
  streetAddress: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type AdminBooking = {
  __typename?: 'AdminBooking';
  authorizedCents?: Maybe<Scalars['Int']['output']>;
  capturedCents?: Maybe<Scalars['Int']['output']>;
  clientName: Scalars['String']['output'];
  discountCode?: Maybe<Scalars['String']['output']>;
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  estimatedDuration: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isInstant: Scalars['Boolean']['output'];
  isTest: Scalars['Boolean']['output'];
  paymentStatus?: Maybe<Scalars['String']['output']>;
  sessionType: SessionType;
  startTime: Scalars['Date']['output'];
  status: ConsultationStatus;
  stylistName: Scalars['String']['output'];
};

export enum AdminBookingFilter {
  NeedsReply = 'NEEDS_REPLY',
  Recent = 'RECENT',
  Upcoming = 'UPCOMING',
}

export enum AdminCalendarState {
  Connected = 'CONNECTED',
  NeedsReconnect = 'NEEDS_RECONNECT',
  NotConnected = 'NOT_CONNECTED',
  NoBookingCalendar = 'NO_BOOKING_CALENDAR',
}

export type AdminConversation = {
  __typename?: 'AdminConversation';
  channelUrl: Scalars['String']['output'];
  lastMessageAt: Scalars['Date']['output'];
  recipient: AdminPerson;
  sender: AdminPerson;
};

export type AdminCreateDiscountCodeInput = {
  codeText: Scalars['String']['input'];
  discountPercentage: Scalars['Int']['input'];
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  stylistId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminDiscountCode = {
  __typename?: 'AdminDiscountCode';
  codeText: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  discountPercentage: Scalars['Int']['output'];
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  stylistName?: Maybe<Scalars['String']['output']>;
  timesPaid: Scalars['Int']['output'];
  timesUsed: Scalars['Int']['output'];
};

export type AdminOverview = {
  __typename?: 'AdminOverview';
  bookableStylists: Scalars['Int']['output'];
  completedLastMonthToDate: Scalars['Int']['output'];
  completedThisMonth: Scalars['Int']['output'];
  listedStylists: Scalars['Int']['output'];
  newClientsLastMonthToDate: Scalars['Int']['output'];
  newClientsThisMonth: Scalars['Int']['output'];
  pendingRequests: Scalars['Int']['output'];
  platformFeeLastMonthToDateCents: Scalars['Int']['output'];
  platformFeeThisMonthCents: Scalars['Int']['output'];
  revenueThisMonthCents: Scalars['Int']['output'];
  staleUnopenedConversations?: Maybe<Scalars['Int']['output']>;
  unopenedConversations?: Maybe<Scalars['Int']['output']>;
  upcomingBookings: Scalars['Int']['output'];
  weeks: Array<AdminWeek>;
};

export type AdminPerson = {
  __typename?: 'AdminPerson';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type?: Maybe<UserType>;
  userId: Scalars['Int']['output'];
};

export type AdminStylist = {
  __typename?: 'AdminStylist';
  address?: Maybe<Address>;
  calendar: AdminCalendarState;
  calendarNeedsReconnect: Scalars['Boolean']['output'];
  city?: Maybe<City>;
  completedSessions: Scalars['Int']['output'];
  customHourlyRate?: Maybe<Scalars['Int']['output']>;
  customInPersonHourlyRate?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  hasCalendar: Scalars['Boolean']['output'];
  instantStylingActive: Scalars['Boolean']['output'];
  isAvailableInPerson: Scalars['Boolean']['output'];
  isTestUser: Scalars['Boolean']['output'];
  lastSeenAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  nextDateWithHours?: Maybe<Scalars['String']['output']>;
  profilePicUrl?: Maybe<Scalars['String']['output']>;
  shareCode?: Maybe<Scalars['String']['output']>;
  status: AdminStylistStatus;
  stylistId: Scalars['Int']['output'];
  tierHourlyRate?: Maybe<Scalars['Int']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  upcomingDaysWithHours: Scalars['Int']['output'];
  upcomingSessions: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type AdminStylistBookingInput = {
  address?: InputMaybe<UpdateAddressInput>;
  customHourlyRate?: InputMaybe<Scalars['Int']['input']>;
  customInPersonHourlyRate?: InputMaybe<Scalars['Int']['input']>;
  isAvailableInPerson: Scalars['Boolean']['input'];
};

export enum AdminStylistStatus {
  Bookable = 'BOOKABLE',
  NotListed = 'NOT_LISTED',
  NoCalendar = 'NO_CALENDAR',
  NoUpcomingHours = 'NO_UPCOMING_HOURS',
}

export type AdminUser = {
  __typename?: 'AdminUser';
  city?: Maybe<City>;
  completedSessions: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  isTestUser: Scalars['Boolean']['output'];
  lastSeenAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  profilePicUrl?: Maybe<Scalars['String']['output']>;
  setupComplete: Scalars['Boolean']['output'];
  type: UserType;
  userId: Scalars['Int']['output'];
};

export type AdminUserList = {
  __typename?: 'AdminUserList';
  clientCount: Scalars['Int']['output'];
  stylistCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  users: Array<AdminUser>;
};

export type AdminWeek = {
  __typename?: 'AdminWeek';
  completed: Scalars['Int']['output'];
  newClients: Scalars['Int']['output'];
  platformFeeCents: Scalars['Int']['output'];
  weekStart: Scalars['String']['output'];
};

export enum AgeRange {
  Age_18_24 = 'AGE_18_24',
  Age_25_34 = 'AGE_25_34',
  Age_35_44 = 'AGE_35_44',
  Age_45_54 = 'AGE_45_54',
  Age_55_64 = 'AGE_55_64',
  Age_65Plus = 'AGE_65_PLUS',
  NoPreference = 'NO_PREFERENCE',
}

export type ApproveInPersonRequestInput = {
  consultationId: Scalars['Int']['input'];
};

export type AvailabilitySlot = {
  __typename?: 'AvailabilitySlot';
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type AvailabilitySlotsInput = {
  currentDate: Scalars['String']['input'];
  eventType: EventType;
  stylistId: Scalars['Int']['input'];
};

export type CancelConsultationInput = {
  cancellationType: ConsultationCancellationType;
  clientId: Scalars['Int']['input'];
  consultationId: Scalars['Int']['input'];
  isOutsideRefundWindow?: InputMaybe<Scalars['Boolean']['input']>;
  stylistId: Scalars['Int']['input'];
};

export type CancelPendingInPersonRequestInput = {
  consultationId: Scalars['Int']['input'];
};

export type CheckClientHasConsultationInput = {
  clientId: Scalars['Int']['input'];
};

export type CheckClientHasConsultationResponse = {
  __typename?: 'CheckClientHasConsultationResponse';
  hasConsultation: Scalars['Boolean']['output'];
};

export enum City {
  Boston = 'BOSTON',
  Chicago = 'CHICAGO',
  Dallas = 'DALLAS',
  LongIsland = 'LONG_ISLAND',
  LosAngeles = 'LOS_ANGELES',
  Miami = 'MIAMI',
  NewYork = 'NEW_YORK',
  PalmBeach = 'PALM_BEACH',
  SanFrancisco = 'SAN_FRANCISCO',
  Seattle = 'SEATTLE',
}

export type Client = {
  __typename?: 'Client';
  aesthetics: Array<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  shareAge: Scalars['Boolean']['output'];
  sizingDetails?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeDefaultPaymentMethodId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type ClientAcceptMatchInput = {
  consultationId: Scalars['Int']['input'];
  paymentId: Scalars['Int']['input'];
  requestId: Scalars['Int']['input'];
  stylistUserId: Scalars['Int']['input'];
};

export type ClientCancelRequestInput = {
  requestId: Scalars['Int']['input'];
};

export type ClientDeclineMatchInput = {
  requestId: Scalars['Int']['input'];
};

export type ClientExitCallInput = {
  sessionName: Scalars['String']['input'];
};

export type ClientExitedCall = {
  __typename?: 'ClientExitedCall';
  clientName: Scalars['String']['output'];
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  estimatedDuration?: Maybe<Scalars['Int']['output']>;
  sessionName: Scalars['String']['output'];
};

export type ClientInput = {
  aesthetics: Array<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  isNewUser?: InputMaybe<Scalars['Boolean']['input']>;
  shareAge?: InputMaybe<Scalars['Boolean']['input']>;
  sizingDetails?: InputMaybe<Scalars['String']['input']>;
};

export type ClientNote = {
  __typename?: 'ClientNote';
  clientId: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  stylistId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ClientNotesInput = {
  clientId: Scalars['Int']['input'];
};

export type Consultation = {
  __typename?: 'Consultation';
  cancelTime?: Maybe<Scalars['Date']['output']>;
  client?: Maybe<Client>;
  clientAttended: Scalars['Boolean']['output'];
  clientId: Scalars['Int']['output'];
  consultationDetails?: Maybe<ConsultationDetails>;
  endTime: Scalars['Date']['output'];
  estimatedDuration: Scalars['Int']['output'];
  estimatedPrice: Scalars['Int']['output'];
  extraTimeMinutes: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isInstant: Scalars['Boolean']['output'];
  overageRate: Scalars['Int']['output'];
  payment?: Maybe<Payment>;
  sessionType: SessionType;
  startTime: Scalars['Date']['output'];
  status: ConsultationStatus;
  stylist?: Maybe<Stylist>;
  stylistAttended: Scalars['Boolean']['output'];
  stylistId: Scalars['Int']['output'];
  videoSession?: Maybe<VideoSession>;
};

export enum ConsultationCancellationType {
  Cancelled = 'CANCELLED',
  ClientNoShow = 'CLIENT_NO_SHOW',
  StylistNoShow = 'STYLIST_NO_SHOW',
}

export type ConsultationDetails = {
  __typename?: 'ConsultationDetails';
  clientNotes?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  style?: Maybe<Scalars['String']['output']>;
};

export type ConsultationInput = {
  id: Scalars['Int']['input'];
};

export enum ConsultationStatus {
  Cancelled = 'CANCELLED',
  ClientNoShow = 'CLIENT_NO_SHOW',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  StylistNoShow = 'STYLIST_NO_SHOW',
  Upcoming = 'UPCOMING',
}

export enum Country {
  Usa = 'USA',
}

export type CreateClientNoteInput = {
  clientId: Scalars['Int']['input'];
  content: Scalars['String']['input'];
};

export type CreateConsultationInput = {
  clientNotes?: InputMaybe<Scalars['String']['input']>;
  clientTimezone: Scalars['String']['input'];
  estimatedDuration: Scalars['Int']['input'];
  isInstant: Scalars['Boolean']['input'];
  paymentId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  sessionType?: InputMaybe<SessionType>;
  startTime: Scalars['Date']['input'];
  style?: InputMaybe<Scalars['String']['input']>;
  stylistId: Scalars['Int']['input'];
};

export type CreateInstantStylingRequestInput = {
  age: AgeRange;
  details?: InputMaybe<Scalars['String']['input']>;
  duration: InstantEventType;
  gender: Gender;
  pricingTier: PricingTier;
  reason: Scalars['String']['input'];
  style: StylingPreferenceRequest;
};

export type CreateLookbookInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
  sendbirdMessageId: Scalars['String']['input'];
  stylistId: Scalars['Int']['input'];
};

export type CreatePaymentIntentInput = {
  amount: Scalars['Int']['input'];
  captureImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  stylistId: Scalars['Int']['input'];
};

export type DateAvailabilitySlotInput = {
  date: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

export type DeclineInPersonRequestInput = {
  consultationId: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteClientNoteInput = {
  id: Scalars['Int']['input'];
};

export type DisconnectCalendarResponse = {
  __typename?: 'DisconnectCalendarResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DiscountCode = {
  __typename?: 'DiscountCode';
  codeText: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  discountPercentage: Scalars['Int']['output'];
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  stylistId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type DiscountCodeValidationResult = {
  __typename?: 'DiscountCodeValidationResult';
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type EndInPersonSessionInput = {
  consultationId: Scalars['Int']['input'];
  extraTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type EndVideoSessionInput = {
  sessionName: Scalars['String']['input'];
};

export type EndVideoSessionResponse = {
  __typename?: 'EndVideoSessionResponse';
  durationSeconds: Scalars['Int']['output'];
  session: VideoSession;
};

export enum EventType {
  InPerson_2Hour = 'IN_PERSON_2_HOUR',
  InPerson_3Hour = 'IN_PERSON_3_HOUR',
  InPerson_4Hour = 'IN_PERSON_4_HOUR',
  InPerson_5Hour = 'IN_PERSON_5_HOUR',
  InPerson_6Hour = 'IN_PERSON_6_HOUR',
  InPerson_7Hour = 'IN_PERSON_7_HOUR',
  InPerson_8Hour = 'IN_PERSON_8_HOUR',
  SixtyMinutes = 'SIXTY_MINUTES',
  ThirtyMinutes = 'THIRTY_MINUTES',
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
}

export type GetClientInput = {
  id: Scalars['Int']['input'];
};

export type GetStylistByShareCodeInput = {
  shareCode: Scalars['String']['input'];
};

export type GetStylistInput = {
  id: Scalars['Int']['input'];
};

export type GetStylistShareProfileUrlInput = {
  stylistId: Scalars['Int']['input'];
};

export enum GraphQlErrorCode {
  CancellationTimeRestricted = 'CANCELLATION_TIME_RESTRICTED',
  ConsultationNotFound = 'CONSULTATION_NOT_FOUND',
  DuplicatePhoneNo = 'DUPLICATE_PHONE_NO',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  InvalidAvailabilitySlot = 'INVALID_AVAILABILITY_SLOT',
  InvalidSessionType = 'INVALID_SESSION_TYPE',
  InvalidSessionTypeInstantCombination = 'INVALID_SESSION_TYPE_INSTANT_COMBINATION',
  NotAuthorized = 'NOT_AUTHORIZED',
  OperationFailed = 'OPERATION_FAILED',
  OverlappingAvailabilitySlots = 'OVERLAPPING_AVAILABILITY_SLOTS',
  PermissionDenied = 'PERMISSION_DENIED',
  ResourceNotFound = 'RESOURCE_NOT_FOUND',
  StylistNotEventAttendee = 'STYLIST_NOT_EVENT_ATTENDEE',
}

export enum InstantEventType {
  FifteenMinutes = 'FIFTEEN_MINUTES',
  FortyFiveMinutes = 'FORTY_FIVE_MINUTES',
  SixtyMinutes = 'SIXTY_MINUTES',
  ThirtyMinutes = 'THIRTY_MINUTES',
}

export type InstantStyling = {
  __typename?: 'InstantStyling';
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  stylistId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type InstantStylingMatchInput = {
  declinedStylistIds: Array<Scalars['Int']['input']>;
  requestId: Scalars['Int']['input'];
};

export type InstantStylingMatchPayload = {
  __typename?: 'InstantStylingMatchPayload';
  resultCode: MatchResultCode;
  stylist?: Maybe<Stylist>;
};

export type InstantStylingMatchStatus = {
  __typename?: 'InstantStylingMatchStatus';
  clientAccepted: Scalars['Boolean']['output'];
  clientCancelled: Scalars['Boolean']['output'];
  clientDeclined: Scalars['Boolean']['output'];
  clientUserId: Scalars['Int']['output'];
  consultationId: Scalars['Int']['output'];
  paymentId: Scalars['Int']['output'];
  requestId: Scalars['Int']['output'];
  stylistAccepted: Scalars['Boolean']['output'];
  stylistDeclined: Scalars['Boolean']['output'];
  stylistUserId: Scalars['Int']['output'];
};

export type InstantStylingRequest = {
  __typename?: 'InstantStylingRequest';
  age: AgeRange;
  client: Client;
  clientId: Scalars['Int']['output'];
  details?: Maybe<Scalars['String']['output']>;
  duration: InstantEventType;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  gender: Gender;
  id: Scalars['Int']['output'];
  pricingTier: PricingTier;
  reason: Scalars['String']['output'];
  status: InstantStylingRequestStatus;
  style: StylingPreferenceRequest;
  stylist?: Maybe<Stylist>;
  stylistId?: Maybe<Scalars['Int']['output']>;
};

export type InstantStylingRequestInput = {
  id: Scalars['Int']['input'];
};

export enum InstantStylingRequestStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
}

export type InstantStylingTimeout = {
  __typename?: 'InstantStylingTimeout';
  message: Scalars['String']['output'];
};

export type JoinVideoSessionInput = {
  sessionName: Scalars['String']['input'];
};

export enum LocationType {
  Apartment = 'APARTMENT',
  Home = 'HOME',
  Other = 'OTHER',
}

export type Lookbook = {
  __typename?: 'Lookbook';
  client?: Maybe<Client>;
  clientId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Int']['output'];
  sendbirdMessageId: Scalars['String']['output'];
  status: LookbookStatus;
  stylist?: Maybe<Stylist>;
  stylistId: Scalars['Int']['output'];
};

export type LookbookPurchased = {
  __typename?: 'LookbookPurchased';
  sendbirdMessageId: Scalars['String']['output'];
};

export type LookbookQueryInput = {
  sendbirdMessageId: Scalars['String']['input'];
};

export enum LookbookStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
}

export type ManageAvailabilityInput = {
  bookingCalendarId?: InputMaybe<Scalars['Int']['input']>;
  calendarIds: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  openHours?: InputMaybe<Array<OpenHoursInput>>;
  stylistId: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type MarkNotificationAsReadInput = {
  notificationId: Scalars['Int']['input'];
};

export enum MatchResultCode {
  NoActiveStylists = 'NO_ACTIVE_STYLISTS',
  NoStylistsMatchCriteria = 'NO_STYLISTS_MATCH_CRITERIA',
  Success = 'SUCCESS',
}

export type Mutation = {
  __typename?: 'Mutation';
  adminCreateDiscountCode: AdminDiscountCode;
  adminSetDiscountCodeActive: Scalars['Boolean']['output'];
  adminSetTestUser: Scalars['Boolean']['output'];
  adminUpdateStylistBooking: Scalars['Boolean']['output'];
  approveInPersonRequest?: Maybe<Consultation>;
  cancelConsultation?: Maybe<Consultation>;
  cancelPendingInPersonRequest?: Maybe<Consultation>;
  clientAcceptMatch: InstantStylingMatchStatus;
  clientCancelRequest: InstantStylingMatchStatus;
  clientDeclineMatch: InstantStylingMatchStatus;
  clientExitCall?: Maybe<Scalars['Boolean']['output']>;
  createClientNote?: Maybe<ClientNote>;
  createClientStripeCustomer?: Maybe<Client>;
  createConsultation?: Maybe<Consultation>;
  createInstantStylingRequest: InstantStylingRequest;
  createLookbook?: Maybe<Lookbook>;
  createPaymentIntent?: Maybe<Payment>;
  createSendbirdSessionToken: SendbirdSessionToken;
  createSignNowDocument: SignNowDocumentResponse;
  createStylistAvailability: Array<Maybe<ScheduleConfig>>;
  createUser: User;
  declineInPersonRequest?: Maybe<Consultation>;
  deleteClientNote?: Maybe<ClientNote>;
  deleteUserAccount: User;
  disconnectCalendar: DisconnectCalendarResponse;
  endInPersonSession?: Maybe<Consultation>;
  endVideoSession?: Maybe<EndVideoSessionResponse>;
  findInstantStylingMatch?: Maybe<InstantStylingMatchPayload>;
  generateShareProfileUrl: StylistShareProfileUrl;
  markNotificationAsRead?: Maybe<Notification>;
  saveDefaultPaymentMethod?: Maybe<PaymentMethod>;
  savePushToken: PushToken;
  sendBookingRequestNotification?: Maybe<Scalars['Boolean']['output']>;
  setDateAvailability: Array<Maybe<StylistAvailabilitySlot>>;
  startInPersonSession?: Maybe<Consultation>;
  startVideoSession?: Maybe<VideoSessionResponse>;
  stylistAbsentTimeout: InstantStylingMatchStatus;
  stylistAcceptMatch: InstantStylingMatchStatus;
  stylistDeclineMatch: InstantStylingMatchStatus;
  submitSourcedByRequest: Scalars['Boolean']['output'];
  toggleInstantActive: InstantStyling;
  toggleStylistFavorite: Scalars['Boolean']['output'];
  /** Tracks user activity when app is opened */
  trackUserActivity: Scalars['Boolean']['output'];
  updateClient: Client;
  updateConsultationPaymentMethod?: Maybe<Consultation>;
  updateLookbookStatus?: Maybe<Lookbook>;
  updateNotificationPreferences: User;
  updateStylist: Stylist;
  updateStylistAvailability: Array<Maybe<ScheduleConfig>>;
  updateStylistStripeSetup: Stylist;
  updateUserAddress: Address;
  updateUserTimeZone: User;
  videoSessionHeartbeat?: Maybe<Scalars['Boolean']['output']>;
};

export type MutationAdminCreateDiscountCodeArgs = {
  input: AdminCreateDiscountCodeInput;
};

export type MutationAdminSetDiscountCodeActiveArgs = {
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type MutationAdminSetTestUserArgs = {
  isTestUser: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type MutationAdminUpdateStylistBookingArgs = {
  input: AdminStylistBookingInput;
  stylistId: Scalars['Int']['input'];
};

export type MutationApproveInPersonRequestArgs = {
  input: ApproveInPersonRequestInput;
};

export type MutationCancelConsultationArgs = {
  input: CancelConsultationInput;
};

export type MutationCancelPendingInPersonRequestArgs = {
  input: CancelPendingInPersonRequestInput;
};

export type MutationClientAcceptMatchArgs = {
  input: ClientAcceptMatchInput;
};

export type MutationClientCancelRequestArgs = {
  input: ClientCancelRequestInput;
};

export type MutationClientDeclineMatchArgs = {
  input: ClientDeclineMatchInput;
};

export type MutationClientExitCallArgs = {
  input: ClientExitCallInput;
};

export type MutationCreateClientNoteArgs = {
  input: CreateClientNoteInput;
};

export type MutationCreateConsultationArgs = {
  input: CreateConsultationInput;
};

export type MutationCreateInstantStylingRequestArgs = {
  input: CreateInstantStylingRequestInput;
};

export type MutationCreateLookbookArgs = {
  input: CreateLookbookInput;
};

export type MutationCreatePaymentIntentArgs = {
  input: CreatePaymentIntentInput;
};

export type MutationCreateStylistAvailabilityArgs = {
  input: ManageAvailabilityInput;
};

export type MutationCreateUserArgs = {
  input: UserInput;
};

export type MutationDeclineInPersonRequestArgs = {
  input: DeclineInPersonRequestInput;
};

export type MutationDeleteClientNoteArgs = {
  input: DeleteClientNoteInput;
};

export type MutationEndInPersonSessionArgs = {
  input: EndInPersonSessionInput;
};

export type MutationEndVideoSessionArgs = {
  input: EndVideoSessionInput;
};

export type MutationFindInstantStylingMatchArgs = {
  input: InstantStylingMatchInput;
};

export type MutationMarkNotificationAsReadArgs = {
  input: MarkNotificationAsReadInput;
};

export type MutationSaveDefaultPaymentMethodArgs = {
  input: PaymentMethodInput;
};

export type MutationSavePushTokenArgs = {
  input: SavePushTokenInput;
};

export type MutationSendBookingRequestNotificationArgs = {
  input: SendBookingRequestNotificationInput;
};

export type MutationSetDateAvailabilityArgs = {
  input: SetDateAvailabilityInput;
};

export type MutationStartInPersonSessionArgs = {
  input: StartInPersonSessionInput;
};

export type MutationStartVideoSessionArgs = {
  input: StartVideoSessionInput;
};

export type MutationStylistAbsentTimeoutArgs = {
  input: StylistAbsentTimeoutInput;
};

export type MutationStylistAcceptMatchArgs = {
  input: StylistAcceptMatchInput;
};

export type MutationStylistDeclineMatchArgs = {
  input: StylistDeclineMatchInput;
};

export type MutationSubmitSourcedByRequestArgs = {
  input: SubmitSourcedByRequestInput;
};

export type MutationToggleInstantActiveArgs = {
  input: ToggleInstantActiveInput;
};

export type MutationToggleStylistFavoriteArgs = {
  input: ToggleStylistFavoriteInput;
};

export type MutationUpdateClientArgs = {
  input: ClientInput;
};

export type MutationUpdateConsultationPaymentMethodArgs = {
  input: UpdateConsultationPaymentMethodInput;
};

export type MutationUpdateLookbookStatusArgs = {
  input: UpdateLookbookStatusInput;
};

export type MutationUpdateNotificationPreferencesArgs = {
  input: UpdateNotificationPreferencesInput;
};

export type MutationUpdateStylistArgs = {
  input: StylistInput;
};

export type MutationUpdateStylistAvailabilityArgs = {
  input: ManageAvailabilityInput;
};

export type MutationUpdateStylistStripeSetupArgs = {
  input: StylistStripeSetupInput;
};

export type MutationUpdateUserAddressArgs = {
  input: UpdateAddressInput;
};

export type MutationUpdateUserTimeZoneArgs = {
  input: UpdateUserTimeZoneInput;
};

export type MutationVideoSessionHeartbeatArgs = {
  input: SendHeartbeatInput;
};

export type NextAvailableSlot = {
  __typename?: 'NextAvailableSlot';
  eventType: EventType;
  formattedDate: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type NextAvailableSlotInput = {
  currentDate: Scalars['String']['input'];
  stylistId: Scalars['Int']['input'];
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['Date']['output'];
  deepLinkUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRead: Scalars['Boolean']['output'];
  openedAt?: Maybe<Scalars['Date']['output']>;
  targetId: Scalars['Int']['output'];
  targetType: NotificationTargetType;
  type: NotificationType;
  userId: Scalars['Int']['output'];
  variables?: Maybe<Scalars['JSON']['output']>;
};

export type NotificationListInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type NotificationListResponse = {
  __typename?: 'NotificationListResponse';
  hasMore: Scalars['Boolean']['output'];
  notifications: Array<Notification>;
  total: Scalars['Int']['output'];
};

export enum NotificationTargetType {
  Consultation = 'CONSULTATION',
  InstantStylingRequest = 'INSTANT_STYLING_REQUEST',
  Message = 'MESSAGE',
}

export enum NotificationType {
  BookingRequestToStylist = 'BOOKING_REQUEST_TO_STYLIST',
  ConsultationCancelled = 'CONSULTATION_CANCELLED',
  ConsultationCancelledPaymentIssueToClient = 'CONSULTATION_CANCELLED_PAYMENT_ISSUE_TO_CLIENT',
  ConsultationClientNoShowToClient = 'CONSULTATION_CLIENT_NO_SHOW_TO_CLIENT',
  ConsultationClientNoShowToStylist = 'CONSULTATION_CLIENT_NO_SHOW_TO_STYLIST',
  ConsultationMeetingScheduledToClient = 'CONSULTATION_MEETING_SCHEDULED_TO_CLIENT',
  ConsultationMeetingScheduledToStylist = 'CONSULTATION_MEETING_SCHEDULED_TO_STYLIST',
  ConsultationReminder = 'CONSULTATION_REMINDER',
  ConsultationReminder_48Hours = 'CONSULTATION_REMINDER_48_HOURS',
  ConsultationReminderDayOfToClient = 'CONSULTATION_REMINDER_DAY_OF_TO_CLIENT',
  ConsultationReminderDayOfToStylist = 'CONSULTATION_REMINDER_DAY_OF_TO_STYLIST',
  ConsultationScheduled = 'CONSULTATION_SCHEDULED',
  ConsultationStylistNoShowToClient = 'CONSULTATION_STYLIST_NO_SHOW_TO_CLIENT',
  ConsultationStylistNoShowToOwner = 'CONSULTATION_STYLIST_NO_SHOW_TO_OWNER',
  ConsultationStylistNoShowToStylist = 'CONSULTATION_STYLIST_NO_SHOW_TO_STYLIST',
  InstantStylingMatchFoundToStylist = 'INSTANT_STYLING_MATCH_FOUND_TO_STYLIST',
  InstantStylingRequestMatch = 'INSTANT_STYLING_REQUEST_MATCH',
  InstantStylingToggleOff = 'INSTANT_STYLING_TOGGLE_OFF',
  InPersonRequestApprovedToClient = 'IN_PERSON_REQUEST_APPROVED_TO_CLIENT',
  InPersonRequestDeclinedToClient = 'IN_PERSON_REQUEST_DECLINED_TO_CLIENT',
  InPersonRequestExpiredToClient = 'IN_PERSON_REQUEST_EXPIRED_TO_CLIENT',
  InPersonRequestExpiredToStylist = 'IN_PERSON_REQUEST_EXPIRED_TO_STYLIST',
  InPersonRequestToStylist = 'IN_PERSON_REQUEST_TO_STYLIST',
  NewMessage = 'NEW_MESSAGE',
}

export type NylasConnection = {
  __typename?: 'NylasConnection';
  accessToken: Scalars['String']['output'];
  email: Scalars['String']['output'];
  grantId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  idToken?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
  stylistId: Scalars['Int']['output'];
  tokenExpiresAt?: Maybe<Scalars['Date']['output']>;
};

export type OpenHoursInput = {
  day: DayOfWeek;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type Payment = {
  __typename?: 'Payment';
  authorizedAmount: Scalars['Int']['output'];
  captured: Scalars['Boolean']['output'];
  capturedAmount?: Maybe<Scalars['Int']['output']>;
  clientId: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountCode?: Maybe<DiscountCode>;
  discountCodeId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  stripeChargeId?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId: Scalars['String']['output'];
  stripePaymentMethodId: Scalars['String']['output'];
  stylistId: Scalars['Int']['output'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  brand?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  last4?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
};

export type Pricing = {
  __typename?: 'Pricing';
  hourlyRate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  tierName: PricingTier;
};

export enum PricingTier {
  Tier1 = 'Tier1',
  Tier2 = 'Tier2',
  Tier3 = 'Tier3',
  Tier4 = 'Tier4',
}

export type PushToken = {
  __typename?: 'PushToken';
  deviceName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  platform?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  activeVideoSession?: Maybe<VideoSession>;
  adminAccess: Scalars['Boolean']['output'];
  adminBookings: Array<AdminBooking>;
  adminConversations: Array<AdminConversation>;
  adminDiscountCodes: Array<AdminDiscountCode>;
  adminOverview: AdminOverview;
  adminStylists: Array<AdminStylist>;
  adminUsers: AdminUserList;
  availabilitySlots: Array<Maybe<AvailabilitySlot>>;
  checkClientHasConsultation?: Maybe<CheckClientHasConsultationResponse>;
  checkSignNowDocumentStatus: Scalars['Boolean']['output'];
  client?: Maybe<Client>;
  clientNotes?: Maybe<Array<Maybe<ClientNote>>>;
  consultation: Consultation;
  consultations: Array<Consultation>;
  getDefaultPaymentMethod?: Maybe<PaymentMethod>;
  getSetupIntent?: Maybe<SetupIntentResponse>;
  getStylistIdByShareCode: StylistByShareCodeResponse;
  getUserNotificationSettings?: Maybe<User>;
  instantStylingRequest: InstantStylingRequest;
  joinVideoSession?: Maybe<VideoSessionResponse>;
  lookbook?: Maybe<Lookbook>;
  nextAvailableSlot?: Maybe<NextAvailableSlot>;
  notifications?: Maybe<NotificationListResponse>;
  pricing: Array<Pricing>;
  schedulingData?: Maybe<StylistNylasData>;
  stripeAccountIsActive: Scalars['Boolean']['output'];
  stripeAccountLink: Scalars['String']['output'];
  stylist: Stylist;
  stylistShareProfileUrl?: Maybe<StylistShareProfileUrl>;
  stylists: Array<Stylist>;
  unreadNotificationsCount?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  validateDiscountCode?: Maybe<DiscountCodeValidationResult>;
};

export type QueryAdminBookingsArgs = {
  filter: AdminBookingFilter;
};

export type QueryAdminUsersArgs = {
  allTime?: InputMaybe<Scalars['Boolean']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  includeTestUsers?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UserType>;
};

export type QueryAvailabilitySlotsArgs = {
  input: AvailabilitySlotsInput;
};

export type QueryCheckClientHasConsultationArgs = {
  input: CheckClientHasConsultationInput;
};

export type QueryCheckSignNowDocumentStatusArgs = {
  documentId: Scalars['String']['input'];
};

export type QueryClientArgs = {
  input: GetClientInput;
};

export type QueryClientNotesArgs = {
  input: ClientNotesInput;
};

export type QueryConsultationArgs = {
  input: ConsultationInput;
};

export type QueryGetStylistIdByShareCodeArgs = {
  input: GetStylistByShareCodeInput;
};

export type QueryInstantStylingRequestArgs = {
  input: InstantStylingRequestInput;
};

export type QueryJoinVideoSessionArgs = {
  input: JoinVideoSessionInput;
};

export type QueryLookbookArgs = {
  input: LookbookQueryInput;
};

export type QueryNextAvailableSlotArgs = {
  input: NextAvailableSlotInput;
};

export type QueryNotificationsArgs = {
  input: NotificationListInput;
};

export type QueryStylistArgs = {
  input: GetStylistInput;
};

export type QueryStylistShareProfileUrlArgs = {
  input: GetStylistShareProfileUrlInput;
};

export type QueryValidateDiscountCodeArgs = {
  input: ValidateDiscountCodeInput;
};

export type SavePushTokenInput = {
  deviceName?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type ScheduleConfig = {
  __typename?: 'ScheduleConfig';
  availabilityCalendarIds: Array<Maybe<Scalars['Int']['output']>>;
  bookingCalendarId?: Maybe<Scalars['Int']['output']>;
  config?: Maybe<Scalars['JSON']['output']>;
  eventType: EventType;
  id: Scalars['Int']['output'];
  nylasConfigId?: Maybe<Scalars['String']['output']>;
  stylistId: Scalars['Int']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
};

export type SendBookingRequestNotificationInput = {
  stylistId: Scalars['Int']['input'];
};

export type SendHeartbeatInput = {
  sessionName: Scalars['String']['input'];
};

export type SendbirdSessionToken = {
  __typename?: 'SendbirdSessionToken';
  expiresAt: Scalars['Float']['output'];
  sessionToken: Scalars['String']['output'];
};

export enum SessionType {
  InPersonEvent = 'IN_PERSON_EVENT',
  InPersonSession = 'IN_PERSON_SESSION',
  Video = 'VIDEO',
}

export type SetDateAvailabilityInput = {
  clearedDates?: InputMaybe<Array<Scalars['String']['input']>>;
  slots: Array<DateAvailabilitySlotInput>;
  stylistId: Scalars['Int']['input'];
};

export type SetupIntentResponse = {
  __typename?: 'SetupIntentResponse';
  clientSecret: Scalars['String']['output'];
  ephemeralKey: Scalars['String']['output'];
};

export type SignNowDocumentResponse = {
  __typename?: 'SignNowDocumentResponse';
  documentId: Scalars['String']['output'];
  signingLink: Scalars['String']['output'];
};

export type StartInPersonSessionInput = {
  consultationId: Scalars['Int']['input'];
};

export type StartVideoSessionInput = {
  consultationId: Scalars['Int']['input'];
  guestId: Scalars['Int']['input'];
};

export enum State {
  Ca = 'CA',
  Fl = 'FL',
  Il = 'IL',
  Ma = 'MA',
  Ny = 'NY',
  Tx = 'TX',
  Wa = 'WA',
}

export enum StylingPreferenceRequest {
  Athleisure = 'ATHLEISURE',
  Bohemian = 'BOHEMIAN',
  Classic = 'CLASSIC',
  Feminine = 'FEMININE',
  Grunge = 'GRUNGE',
  Maximalist = 'MAXIMALIST',
  Minimalist = 'MINIMALIST',
  NoPreference = 'NO_PREFERENCE',
  Streetwear = 'STREETWEAR',
  Trendy = 'TRENDY',
  Vintage = 'VINTAGE',
}

export type Stylist = {
  __typename?: 'Stylist';
  aesthetics: Array<Scalars['String']['output']>;
  bio: Scalars['String']['output'];
  computedInPersonAvailability: Scalars['Boolean']['output'];
  customHourlyRate?: Maybe<Scalars['Int']['output']>;
  customInPersonHourlyRate?: Maybe<Scalars['Int']['output']>;
  expertise: Array<Scalars['String']['output']>;
  hasCompletedStripeSetup: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  instantStyling?: Maybe<InstantStyling>;
  isAvailableInPerson: Scalars['Boolean']['output'];
  isEventAttendee: Scalars['Boolean']['output'];
  isFavorited: Scalars['Boolean']['output'];
  landscapeImage?: Maybe<Scalars['String']['output']>;
  nylasConnections?: Maybe<Array<Maybe<NylasConnection>>>;
  portraitImages: Array<Scalars['String']['output']>;
  pricing?: Maybe<Pricing>;
  scheduleConfigs?: Maybe<Array<Maybe<ScheduleConfig>>>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  substack?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type StylistAbsentTimeoutInput = {
  requestId: Scalars['Int']['input'];
  stylistUserId: Scalars['Int']['input'];
};

export type StylistAcceptMatchInput = {
  clientUserId: Scalars['Int']['input'];
  requestId: Scalars['Int']['input'];
};

export type StylistAvailabilitySlot = {
  __typename?: 'StylistAvailabilitySlot';
  date: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
};

export type StylistByShareCodeResponse = {
  __typename?: 'StylistByShareCodeResponse';
  stylistId: Scalars['Int']['output'];
};

export type StylistCalendar = {
  __typename?: 'StylistCalendar';
  calendarId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isOwnedByUser: Scalars['Boolean']['output'];
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
};

export type StylistDeclineMatchInput = {
  clientUserId: Scalars['Int']['input'];
  requestId: Scalars['Int']['input'];
};

export type StylistInput = {
  aesthetics: Array<Scalars['String']['input']>;
  bio: Scalars['String']['input'];
  expertise: Array<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  isAvailableInPerson?: InputMaybe<Scalars['Boolean']['input']>;
  landscapeImage?: InputMaybe<Scalars['String']['input']>;
  portraitImages: Array<Scalars['String']['input']>;
  substack?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
};

export type StylistNylasData = {
  __typename?: 'StylistNylasData';
  availabilitySlots: Array<Maybe<StylistAvailabilitySlot>>;
  calendars: Array<Maybe<StylistCalendar>>;
  nylasConnections: Array<Maybe<NylasConnection>>;
  openHours: Array<Maybe<StylistOpenHours>>;
  scheduleConfigs: Array<Maybe<ScheduleConfig>>;
  stylistId: Scalars['Int']['output'];
};

export type StylistOpenHours = {
  __typename?: 'StylistOpenHours';
  day: DayOfWeek;
  endTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
};

export type StylistShareProfileUrl = {
  __typename?: 'StylistShareProfileUrl';
  shareProfileUrl: Scalars['String']['output'];
};

export type StylistStripeSetupInput = {
  hasCompletedStripeSetup: Scalars['Boolean']['input'];
};

export type SubmitSourcedByRequestInput = {
  clientUserId: Scalars['Int']['input'];
  color: Scalars['String']['input'];
  needByDate: Scalars['String']['input'];
  productImageUrl: Scalars['String']['input'];
  productName: Scalars['String']['input'];
  size: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  userEvents?: Maybe<UserEvent>;
};

export type ToggleInstantActiveInput = {
  isActive: Scalars['Boolean']['input'];
};

export type ToggleStylistFavoriteInput = {
  stylistId: Scalars['Int']['input'];
};

export type UpdateAddressInput = {
  accessDetails?: InputMaybe<Scalars['String']['input']>;
  city: City;
  country: Country;
  locationType: LocationType;
  state: State;
  streetAddress: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type UpdateConsultationPaymentMethodInput = {
  consultationId: Scalars['Int']['input'];
};

export type UpdateLookbookStatusInput = {
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  sendbirdMessageId: Scalars['String']['input'];
  status: LookbookStatus;
};

export type UpdateNotificationPreferencesInput = {
  emailNotificationsEnabled: Scalars['Boolean']['input'];
  pushNotificationsEnabled: Scalars['Boolean']['input'];
};

export type UpdateUserTimeZoneInput = {
  timeZone: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  auth0Id: Scalars['String']['output'];
  birthDate?: Maybe<Scalars['Date']['output']>;
  client?: Maybe<Client>;
  email: Scalars['String']['output'];
  emailNotificationsEnabled: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  id: Scalars['Int']['output'];
  isTestUser: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePicUrl: Scalars['String']['output'];
  pushNotificationsEnabled: Scalars['Boolean']['output'];
  stylist?: Maybe<Stylist>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type: UserType;
};

/** Includes all user events */
export type UserEvent =
  | ClientExitedCall
  | InstantStylingMatchStatus
  | InstantStylingTimeout
  | LookbookPurchased
  | VideoCallDisconnected
  | VideoCallStarted;

export type UserInput = {
  auth0Id: Scalars['String']['input'];
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePicUrl: Scalars['String']['input'];
  shareAge?: InputMaybe<Scalars['Boolean']['input']>;
  signNowDocumentId?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  type: UserType;
};

export enum UserType {
  Client = 'CLIENT',
  Stylist = 'STYLIST',
}

export type ValidateDiscountCodeInput = {
  codeText: Scalars['String']['input'];
  stylistId?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoCallDisconnected = {
  __typename?: 'VideoCallDisconnected';
  sessionName: Scalars['String']['output'];
};

export type VideoCallStarted = {
  __typename?: 'VideoCallStarted';
  sessionName: Scalars['String']['output'];
};

export type VideoSession = {
  __typename?: 'VideoSession';
  consultation?: Maybe<Consultation>;
  consultationId: Scalars['Int']['output'];
  endedAt?: Maybe<Scalars['Date']['output']>;
  guestId: Scalars['Int']['output'];
  hostId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  sessionName: Scalars['String']['output'];
  startedAt: Scalars['Date']['output'];
};

export type VideoSessionResponse = {
  __typename?: 'VideoSessionResponse';
  session: VideoSession;
  /** Access token for Twilio-based sessions. Exactly one of zoomToken or twilioToken is expected to be non-null based on the active video provider. If both are null, no video provider token is available for this session. */
  twilioToken?: Maybe<Scalars['String']['output']>;
  /** Access token for Zoom-based sessions. Exactly one of zoomToken or twilioToken is expected to be non-null based on the active video provider. If both are null, no video provider token is available for this session. */
  zoomToken?: Maybe<Scalars['String']['output']>;
};

export type MutationResult<T extends keyof Mutation> = Pick<Mutation, T>;
export type QueryResult<T extends keyof Query> = Pick<Query, T>;
export type SubscriptionResult<T extends keyof Subscription> = Pick<
  Subscription,
  T
>;
